import { render, staticRenderFns } from "./ProjectBookingAssistant.vue?vue&type=template&id=6a0f3976&scoped=true&lang=pug&"
import script from "./ProjectBookingAssistant.vue?vue&type=script&lang=ts&"
export * from "./ProjectBookingAssistant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0f3976",
  null
  
)

export default component.exports